import React from "react";
import { ClassificationIcon, StringValue } from "@sscs/ui";
import styles from "./networkingUrlValue.module.scss";
const NetworkingUrlValue = ({ value, classification, servicesCount = 0, searchRegex = "", }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles["uri-value"] },
            classification ? (React.createElement(ClassificationIcon, { classification: classification })) : null,
            React.createElement("div", null,
                React.createElement(StringValue, { value: value, regex: searchRegex }))),
        servicesCount > 0 ? (React.createElement("div", { className: styles.services },
            servicesCount.toLocaleString(),
            " remote service",
            servicesCount !== 1 ? "s" : "")) : null));
};
export default NetworkingUrlValue;
//# sourceMappingURL=NetworkingUrlValue.js.map